module.exports = __webpack_public_path__ + "static/media/indicator.a3a1bac1.png";